function initBoostSettingsFacebookPageChooser() {
    $("#fb-pageaccess-boost-settings").off('click').on("click", function () {

        var button = $(this);
        var indicator = button.closest('.fb-btn-holder').find(".fb-btn-loading");
        var lookForPopup = button.closest('.fb-btn-holder').find(".fb-look-for-popup");
        var permissions = ['pages_manage_ads', 'business_management', 'pages_manage_metadata', 'pages_read_engagement', 'pages_read_user_content'];
        button.hide();
        indicator.show();
        lookForPopup.show();

        var postPermission = function (response) {

            lookForPopup.hide();
            if (response.status === 'connected') {
                var fbUserId = response.authResponse.userID;
                jQuery('input[name="fb_user_id"]').val(fbUserId);

                var fbAccessToken = response.authResponse.accessToken;
                jQuery('input[name="fb_access_token"]').val(response.authResponse.accessToken);

                var scopes = response.authResponse.grantedScopes.split(',');
                var missingPermissions = permissions.filter(function(permission) { return scopes.indexOf(permission) === -1; });

                if (missingPermissions.length === 0) {
                    console.log('All Permissions are accounted for!');

                    jQuery.post('/launchpad/getpages/boost', {fb_user_id: fbUserId, fb_access_token: fbAccessToken}, function(pageids, textStatus) {
                        //if there is one page which we have been given permissions use it
                        if (pageids.length > 0){
                            $("#fb-initial-login").hide();
                            $("#fb-choose-page").show();
                            //selector
                            var allItems = '';
                            for (var i=0; i < pageids.length; i++){
                                allItems +=
                                    '<a data-fb-page-access-token="' + pageids[i]['access_token'] + '" data-page-id="' + pageids[i]['id'] + '" href="#" class="fb-page">\n' +
                                    '<img id="'+pageids[i]['id'] + '" class="fb-icon" src="https://graph.facebook.com/'+pageids[i]['id'] + '/picture?type=square" width="40" />' +
                                    '<span class="fb-page-name">'+pageids[i]['name']+'</span>' +
                                    '</a>'
                            }
                            $("#fb-pages").empty().append(allItems).show();

                        } else {
                            button.show();
                            indicator.hide();
                            $("#fb-initial-login").show();
                            $("#to-publish").hide();
                            $("#fb-choose-page").hide();
                            $("#to-publish-error-page").show();
                        }
                    }).fail(function( jqxhr, textStatus, error ) {
                        button.show();
                        indicator.hide();
                        $("#fb-initial-login").show();
                        $("#to-publish").hide();
                        $("#fb-choose-page").hide();
                        $("#to-publish-error-page").show();
                    });

                } else {
                    console.log('Missing the following permissions: ' + missingPermissions.join());
                    button.show();
                    indicator.hide();
                    $("#fb-initial-login").show();
                    $("#to-publish").hide();
                    $("#fb-choose-page").hide();
                    $("#to-publish-error-perm").show();
                }

            } else {
                indicator.hide();
                button.show();
            }
        };

        FB.login(postPermission, {
            scope: permissions.join(),
            return_scopes: true,
        });

    });

    var removingCurrentFaceBookPageRequest = false;

    $(".remove-current").on("click", function (e) {
        $("input[name=facebook_page][value=fb_page_default]").attr('checked', 'checked').click();
        removingCurrentFaceBookPageRequest = true;
    });

    $("#form_facebook_page").on("submit", function (e) {

        const fBPageIdInputElement = $("input[name='fb_page_id']");
        const selectedFbPageElement = $("input[name='facebook_page']:checked");
        const selectedFbPage = selectedFbPageElement.val();
        const selectedFbPageID = selectedFbPageElement.data("fb-page-id");

        if (fBPageIdInputElement.val()) {
            return;
        }
        else if (removingCurrentFaceBookPageRequest) {
            fBPageIdInputElement.val("");
            return;
        }
        else if ("fb_page_current" === selectedFbPage || "fb_page_default" === selectedFbPage) {
            fBPageIdInputElement.val(selectedFbPageID); // that's it, just submit to the server now
            return;
        }
        else if ("fb_page_custom" === selectedFbPage ) { // "fb_page_custom" + need to choose a page

            e.preventDefault();

            $('body').css('overflow', 'hidden'); // prevent scrolling the body when in modal

            // start listening for page selection
            $("#set-facebook-page").removeClass('fb-modal-hide').on("click", ".fb-page", function (e) {

                e.preventDefault();
                const fbPageID = $(e.currentTarget).data("page-id");
                const fbPageToken = $(e.currentTarget).data("fb-page-access-token");

                $("input[name='fb_page_id']").val(fbPageID);
                $("input[name='fb_page_access_token']").val(fbPageToken);
                $("#form_facebook_page").trigger("submit");
            });

            // create a listener to listen for a closing click outside of the modal
            $(".fb-modal").on("click", function (e) {
                //if you click on anything except the modal itself or the "open modal" link, close the modal
                if (!$(e.target).closest(".fb-connect").length) {
                    cancelFbPageSelect();
                }
            });
            return;
        }
        else {
            throw new Error ("Unexpected radio button selected: "+selectedFbPage);
        }
    });

    $(".facebook-cancel-button").on("click", function (e) {
        e.preventDefault();
        cancelFbPageSelect();
    });

    function cancelFbPageSelect() {
        $("#set-facebook-page").off().addClass('fb-modal-hide');
        $('body').css('overflow', 'auto');  // allow scrolling of body when we leave the modal
        $("input[name='fb_page_id']").val(null);
    }

}

$(document).ready(function () {
    initBoostSettingsFacebookPageChooser();
});

$('body').on('context_changed', function (srcElement, arg) {
    initBoostSettingsFacebookPageChooser();
});

